import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import clsx from 'clsx';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { Button } from '../../../atoms/Button/StyledButton';
import '../Profile.css'
import { ModalType, OptionTypes, StartUp, initialStateModal } from '../../../types/types';
import { MAX_FILE_SIZE, SUPPORTED_FORMATS, SUPPORTED_FORMATS_extensions, NOT_PERMITTED_VALUES } from '../../../../shared/const';
import { UploadFileComponent } from '../../../molecules/UploadFileComponent/UploadFileComponent';
import placeholder from '../../../../img/placeholder.png'
import { AppGeneralContext } from '../../../../shared/GeneralContext/GeneralContext';
import useMediaQuery from '../../../../hook/useMediaQuery';
import { MediaMobile, MediaTablet } from '../../../../api/const/MediaQuery';
import SelectComponent from '../../../atoms/Select/SelectComponent';
import { deleteTag, getConstitutionStatusList, getSectorList, getUser, postAddTag, postCitiesList, postEditStartUp } from '../../../../api/Api';
import imgLogo from './../../../../assets/logo192.png';
import imgCover from './../../../../assets/InnovationMatchPress.jpg';

export const ProfileStartUpEdit = () => {
    const [isEditView, setIsEditView] = useState<boolean>(false)
    const tablet = useMediaQuery(MediaTablet)
    const mobile = useMediaQuery(MediaMobile)
    const navigate = useNavigate()
    const [deleteImageCover, setDeleteImageCover] = useState(false)
    const [deleteImageLogo, setDeleteImageLogo] = useState(false)


    const startUpEditInfoSchema = Yup.object().shape({
        sector: Yup.object().shape({
            value: Yup.string().required('Please select an option from the dropdown menu.'),
            label: Yup.string().required('Please select an option from the dropdown menu.')
        })
            .required('Please select an option from the dropdown menu.'),
        constitutionStatus: Yup.object().shape({
            value: Yup.string().required('Please select an option from the dropdown menu.'),
            label: Yup.string().required('Please select an option from the dropdown menu.')
        })
            .required('Please select an option from the dropdown menu.'),
        description: Yup.string()
            .nullable()
            .max(5000, 'Description is too long, use at most 5000 characters.')
            .test('content check',
                'Description can not contain link or email', (value) => {
                    return NOT_PERMITTED_VALUES.some(v => value?.toLowerCase().includes(v)) ? false : true
                }),
        pitch: Yup.string()
            .nullable()
            .max(5000, 'Pitch is too long, use at most 5000 characters.')
            .test('content check',
                'Pitch can not contain link or email', (value) => {
                    return NOT_PERMITTED_VALUES.some(v => value?.toLowerCase().includes(v)) ? false : true
                }),
        imageFile: Yup.mixed()
            .nullable()
            .test('format check', `Image format not valid, supported format are ${SUPPORTED_FORMATS_extensions}`, (value: File) => {
                if (value) {
                    return SUPPORTED_FORMATS.includes(value.type)
                } else {
                    return true
                }
            })
            .test('size check', 'Image size too big, max size is 15MB', (value: File) => {
                if (value) {
                    return value.size <= MAX_FILE_SIZE
                } else {
                    return true
                }
            })
            // .test('size check',
            //     'Dimensions not valid, please  with a 16:9 aspect ratio',
            //     async (value: File) => {

            //         const imageWidthAndHeight = (provideFile: File) => {
            //             const imgDimensions: { width: number | null, height: number | null } = { width: null, height: null };

            //             return new Promise(resolve => {
            //                 const reader = new FileReader();

            //                 reader?.readAsDataURL(provideFile);
            //                 reader.onload = function () {
            //                     const img = new Image();
            //                     img.src = reader.result as string;

            //                     img.onload = function () {
            //                         imgDimensions.width = img.width;
            //                         imgDimensions.height = img.height;

            //                         resolve(imgDimensions);
            //                     }
            //                 };
            //             });
            //         }

            //         if (value) {

            //             const imgDimensions: any = await imageWidthAndHeight(value);
            //             const imageAspectRatio = imgDimensions.width / imgDimensions.height
            //             const imageAspectRatioRound = Math.round((imageAspectRatio + Number.EPSILON) * 100) / 100;
            //             const standardAspecRatio = Math.round(((16 / 9) + Number.EPSILON) * 100) / 100;
            //             const correctDimension = imageAspectRatioRound === standardAspecRatio

            //             if (!correctDimension) {
            //                 setDimensionNotValid(true)
            //                 return false
            //             } else {
            //                 setDimensionNotValid(false)
            //                 return true
            //             }
            //         } else {
            //             return true
            //         }
            //     }),
            ,
        logoFile: Yup.mixed()
            .nullable()
            .test('format check', `Logo format not valid, supported format are ${SUPPORTED_FORMATS_extensions}`, (value: File) => {

                if (value) {
                    return SUPPORTED_FORMATS.includes(value.type)
                } else {
                    return true
                }
            })
            .test('size check', 'Image size too big, max size is 15MB', (value: File) => {
                if (value && value.size) {
                    return value.size <= MAX_FILE_SIZE
                } else {
                    return true
                }
            })
            // .test('size check',
            //     'Dimensions not valid, please upload square image max 512px x 512px',
            //     async (value: File) => {
            //        
            //         const imageWidthAndHeight = (provideFile: File) => {
            //             const imgDimensions = { width: null, height: null };

            //             return new Promise(resolve => {
            //                 const reader = new FileReader();

            //                 reader?.readAsDataURL(provideFile);
            //                 reader.onload = function () {
            //                     const img = new Image();
            //                     img.src = reader.result as any;

            //                     img.onload = function () {
            //                         imgDimensions.width = img.width as any;
            //                         imgDimensions.height = img.height as any;

            //                         resolve(imgDimensions);
            //                     }
            //                 };
            //             });
            //         }

            //         if (value) {
            //             const imgDimensions: any = await imageWidthAndHeight(value);
            //             const isSquare = imgDimensions.height === imgDimensions.width
            //             const heightIsValid = imgDimensions.height <= 512
            //             const widthIsValid = imgDimensions.width <= 512
            //             const correctDimension = heightIsValid && widthIsValid

            //             if (!isSquare || !correctDimension) {
            //                 setDimensionLogoNotValid(true)
            //                 return false
            //             } else {
            //                 setDimensionLogoNotValid(false)
            //                 return true
            //             }
            //         } else {
            //             return true
            //         }
            //     })
    });

    const tagSchema = Yup.object().shape({
        tag: Yup.string()
            .max(20, 'Too Long!, max 20 char'),
    });

    const ctx = useContext(AppGeneralContext)
    const startUp = useMemo(() => ctx.startUp, [ctx.startUp])
    const role = useMemo(() => ctx.user?.role, [ctx.user?.role])
    const [selectedImage, setSelectedImage] = useState<File>()
    const [selectedImageLogo, setSelectedImageLogo] = useState<File>()
    const [errorImage, setErrorImage] = useState("")
    const [errorLogo, setErrorLogo] = useState("")
    const [sectorOptions, setsectorOptions] = useState<OptionTypes[]>()
    const [loadingSectorOptions, setLoadingSectorOptions] = useState<boolean>()
    const [cities, setCities] = useState<OptionTypes[]>()
    const [city, setCity] = useState<string>("")
    const [statusOptions, setstatusOptions] = useState<OptionTypes[]>()
    const [loadingStatusOptions, setLoadingStatusOptions] = useState<boolean>()
    const [dimensionNotValid, setDimensionNotValid] = useState<boolean>()
    const [dimensionLogoNotValid, setDimensionLogoNotValid] = useState<boolean>()


    useEffect(() => {
        if (city.length >= 3) {
           callCity()
        } else {
          setCities([])
        }
      }, [city.length])
    
      useEffect(()=>{
        callCity()  
      },[])
      
      function callCity (){
        postCitiesList({ data: city }).then((res) => {
    
            if (!res.isSuccess || !res.response) {
              ctx.setErrorModal(res.error)
              return false
            }
      
            const response = res.response.data
            setCities(response)
          })
      }


    const formik = useFormik<StartUp>({
        initialValues: role as StartUp,
        validationSchema: startUpEditInfoSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })

            const req = new FormData();

            if (!!values.logoFile) {
                req.append("logoFile", values.logoFile)
            }
            if (!!values.imageFile) {
                req.append("coverFile", values.imageFile)
            }


            if (deleteImageCover) {
                req.append("coverUrl", "");
            } else {
                if (!!values.coverUrl) {
                    req.append("coverUrl", values.coverUrl);
                }
            }
            
            if (deleteImageLogo) {
                req.append("logoUrl", "");
            } else {
                if (!!values.logoUrl) {
                    req.append("logoUrl", values.logoUrl)
                }
            }

            req.append("sectorId", values.sector?.value ?? "");
            req.append("description", values.description ?? "");
            req.append("pitch", values.pitch ?? "");
            req.append("constitutionStatusId", values.constitutionStatus?.value ?? "");
            req.append("cityId", values.city?.value ?? "");

            postEditStartUp(req).then(async (res) => {

                if (!res.isSuccess || !res.response) {
                    ctx.setErrorModal(res.error)
                    setSubmitting(false)
                    return
                }

                if (ctx.loginType) {
                    ctx.getUserData(ctx.loginType).then(() => {
                        setIsEditView(false)
                        setDeleteImageCover(false)
                        setDeleteImageLogo(false)
                        setSubmitting(false)
                    })


                }
            })
            setSubmitting(false)
            setDeleteImageCover(false)
            setDeleteImageLogo(false)
            ctx.setClosedModal()
        }
    })

   


    const formikTag = useFormik({
        initialValues: { tag: "" },
        validationSchema: tagSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })


            const data = values.tag
            postAddTag({ data }).then((res) => {

                if (!res.isSuccess || !res.response) {
                    ctx.setErrorModal(res.error)
                    return false
                }

                formikTag.setFieldValue("tag", "")


                if (ctx.loginType) {
                    ctx.getUserData(ctx.loginType).then(() => {
                        // setIsEditView(false)
                        setTimeout(() => ctx.setClosedModal(), 1000)
                    })

                }
            })
        }
    })


    const getOptionsSector = () => {
        setLoadingSectorOptions(true)
        getSectorList().then((res) => {
            setLoadingSectorOptions(false)

            if (!res.isSuccess || !res.response) {
                ctx.setErrorModal(res.error)
                return false
            }

            const response = res.response
            setsectorOptions(response.sectors)
        })
    }

    const getOptionsStatus = () => {
        setLoadingSectorOptions(true)
        getConstitutionStatusList().then((res) => {
            setLoadingStatusOptions(false)

            if (!res.isSuccess || !res.response) {
                ctx.setErrorModal(res.error)
                return false
            }

            const response = res.response
            setstatusOptions(response.statuses)
        })
    }

    const removeTag = (tagId: string) => {
        ctx.setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })

        deleteTag(tagId).then((res) => {
            if (!res.isSuccess || !res.response) {
                ctx.setErrorModal(res.error)
                return false
            }

            if (ctx.loginType) {
                ctx.getUserData(ctx.loginType).then(() => {
                    // setIsEditView(false)
                })
            }
            ctx.setClosedModal()
        })
    }

    useEffect(() => {
        getOptionsSector()
        getOptionsStatus()
    }, [])

   

    return (
        <>
            <form onSubmit={formik.handleSubmit} id="form1" autoComplete='off'>
                <div className={clsx(" m-0 p-0  container-fluid ", {
                    "me-5": !tablet,
                    "me-3": tablet
                })}>
                    <div className={clsx("row d-flex m-0 p-0 align-items-center flex-wrap pe-3 pb-0", {
                        "mt-5": !tablet,
                        "mt-3": tablet
                    })}>
                        <div className={clsx('d-flex m-0 p-0', {
                            " col-7": !tablet,
                            " col-6": (tablet && !mobile),
                            " col-12": (tablet && mobile)
                        })}>
                            <h3>Hi <span className='tx-primary'>{startUp?.name},</span></h3>
                        </div>
                        <div className={clsx('d-flex   align-items-center  pb-1 m-0 p-0 h-100', {
                            " col-5 justify-content-end": !tablet,
                            " col-6 justify-content-end": (tablet && !mobile),
                            " col-12 justify-content-start": (tablet && mobile)
                        })}>
                            {!isEditView && <Button className={clsx('mt-1  me-2', {
                                "ms-1": !tablet,
                                "ms-0": tablet
                            })} background='var(--white)' uppercase text='edit' onClick={() => setIsEditView(true)} />}
                            <Button className='mt-1' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='upgrade plan' onClick={() => navigate("/start-up/profile/upgrade-plan")} />
                        </div>
                    </div>
                    <div className={clsx("row d-flex m-0 p-0  start-up-profile-container   pe-3 pb-0", {
                        "mt-3   ": !tablet,
                        "mt-2": tablet
                    })}>
                        <div className={clsx('d-flex m-0 p-0 flex-wrap', {
                            " col-7 pe-2": !tablet,
                            " col-12": tablet
                        })}>
                            {isEditView ?
                                <>
                                    <div className='image-container  cursor-pointer position-relative  m- p-0   '>
                                        <div className='tag-plan '>{startUp?.currentPlan?.title}</div>
                                        <UploadFileComponent
                                            inputName='imageFile'
                                            className='image-profile'
                                            url={startUp?.coverUrl ? `${ctx.baseUri}${startUp?.coverUrl}` : imgCover}
                                            formik={formik}
                                            aspectRatio={"16/9"}
                                            dimensioni="800x450px"
                                            file={selectedImage}
                                            fileType={".jpeg, .jpg, .gif, .png"}
                                            callback={setSelectedImage}
                                            label=""
                                            id='imageFile'
                                            setError={setErrorImage}
                                            setDeleteImage={setDeleteImageCover}
                                            imageDeleted={deleteImageCover}
                                            imgPlaceholder={imgCover}
                                            dimensionNotValid={dimensionNotValid}
                                        />
                                        <div className='img-logo cursor-pointer  ' style={{ height:"110px", width:"110px"}}>
                                            <UploadFileComponent
                                                inputName='logoFile'
                                                url={startUp?.logoUrl ? `${ctx.baseUri}${startUp?.logoUrl}` : imgLogo}
                                                formik={formik}
                                                aspectRatio={"1/1"}
                                                dimensioni="512x512px"
                                                file={selectedImageLogo}
                                                fileType={".jpeg, .jpg, .gif, .png"}
                                                callback={setSelectedImageLogo}
                                                label=""
                                                id='logoFile'
                                                checkImgDimension={{ maxHeight: 512, maxWidth: 512, square: true }}
                                                setError={setErrorLogo}
                                                setDeleteImage={setDeleteImageLogo}
                                                imageDeleted={deleteImageLogo}
                                                imgPlaceholder={imgLogo}
                                                dimensionNotValid={dimensionLogoNotValid}
                                            />
                                        { !errorLogo && !formik.errors.logoFile && !formik.touched.logoFile && <div className='p-0  adviceLogo '> Upload a logo with 1:1 ratio,  max  dimension 512px x 512px and weighing less than 15 MB  </div>}
                                        </div>
                                    </div>
                                    <div className={clsx("mb-3",{"mt-6": !tablet}, {"mt-2": tablet})}>
                                    { !errorImage && !formik.errors.imageFile  && !formik.touched.imageFile && <div className='p-0 m-0 advice'> Upload an image with a 16:9 aspect ratio (ex. 1920px x 1080px)  and weighing less than 15 MB </div>}
                                    {errorImage && <div id="feedback" className=' text-error'>{errorImage}</div>}
                                    {errorLogo && <div id="feedback" className=' text-error'>{errorLogo}</div>}
                                    {formik.errors.imageFile && formik.touched.imageFile && <div id="feedback" className='text-error'>{formik.errors.imageFile}</div>  }
                                    {formik.errors.logoFile && formik.touched.logoFile && <div id="feedback" className='  text-error '>{formik.errors.logoFile}</div> }
                                    </div>
                                </>
                                :
                                <div className='image-container position-relative mb-5'>
                                    <div className='tag-plan'>{startUp?.currentPlan?.title}</div>
                                    <img className='w-100 img-cover' src={startUp?.coverUrl ? `${ctx.baseUri}${startUp?.coverUrl}` : imgCover} alt="start up image" />
                                    <div className='img-logo'>
                                        <img className='w-100 logo-s' src={startUp?.logoUrl ? `${ctx.baseUri}${startUp?.logoUrl}` : imgLogo} alt="logo startup" />
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={clsx('d-flex  flex-column justify-content-start align-items-center  pb-1 m-0 p-0 h-100', {
                            " col-5 ": !tablet,
                            " col-12": tablet
                        })}>

                            <div className="row  w-100 m-0 p-0">
                                <div className={clsx('d-flex  flex-column justify-content-start align-items-start  m-0 p-0 h-100 mb-3 col-12')}>
                                    <h5 className='fw-700 '>City:</h5>
                                    {isEditView ?
                                        <SelectComponent
                                            options={cities ? cities : []}
                                            fieldName={'city'}
                                            setSelectSearch={setCity}
                                            formik={formik}
                                            isSearchable
                                            className={"w-100 "}
                                            value={!!formik.values.city?.value ? formik.values.city : null}
                                        />
                                        : <p className='department m-0 p-0'>{startUp?.city?.label}</p>

                                    }
                                    {formik.errors.city && formik.touched.city && <div className='text-error' id="companyName">{formik.errors.city}</div>}
                                </div>
                            </div>
                            <div className="row  w-100 m-0 p-0">
                                <div className={clsx('d-flex flex-column justify-content-start align-items-start  m-0 p-0 h-100', {
                                    " col-6 pe-3": !tablet,
                                    " col-12 pe-0": tablet
                                })}>
                                    <h5 className='fw-700 '>Industry:</h5>
                                    {isEditView ?
                                        <>
                                            <SelectComponent
                                                isLoading={loadingSectorOptions}
                                                formik={formik}
                                                className={"w-100 "}
                                                options={sectorOptions ?? []}
                                                fieldName={'sector'}
                                                value={!!formik.values.sector?.value ? formik.values.sector : null}
                                            />
                                            {formik.errors.sector && formik.touched.sector && <div className='text-error ms-2' id="sector">{formik.errors.sector}</div>}
                                        </>
                                        :
                                        <p className='department m-0 p-0'>{startUp?.sector?.label}</p>
                                    }
                                </div>
                                <div className={clsx('d-flex  flex-column justify-content-start align-items-start  m-0 p-0 h-100', {
                                    " col-6 ": !tablet,
                                    " col-12 ": tablet
                                })}>
                                    <h5 className={clsx('fw-700 ', {
                                        "mt-2": tablet
                                    })}>
                                        Status:
                                    </h5>
                                    {isEditView ?
                                        <>
                                            <SelectComponent
                                                isLoading={loadingStatusOptions}
                                                formik={formik}
                                                className={"w-100"}
                                                options={statusOptions ?? []}
                                                fieldName={'constitutionStatus'}
                                                value={!!formik.values.constitutionStatus?.label ? formik.values.constitutionStatus : null}
                                            />
                                            {formik.errors.constitutionStatus && formik.touched.constitutionStatus && <div className='text-error ms-2' id="state">{formik.errors.constitutionStatus}</div>}
                                        </>
                                        :
                                        <p className='department '>{startUp?.constitutionStatus?.label}</p>
                                    }
                                </div>
                            </div>
                            <div className="row  w-100 m-0 p-0 ">
                                <div className={'d-flex col-12 flex-column justify-content-start align-items-start  pb-1 m-0 p-0 h-100'}>
                                    {isEditView ?
                                        <>
                                            <h5 className='fw-700 mt-3'>Description:</h5>
                                            <textarea
                                                style={{ minHeight: "180px" }}
                                                placeholder='Add description'
                                                {...formik.getFieldProps('description')}
                                                className="form-input "
                                                onChange={formik.handleChange}
                                                onBlur={() => formik.setFieldTouched("description", true)}
                                                value={formik.values.description ? formik.values.description : undefined}
                                                name="description"
                                            />
                                            {formik.errors.description && formik.touched.description && <div className='text-error ms-2' id="description">{formik.errors.description}</div>}
                                        </>
                                        :
                                        <>
                                            <h5 className='fw-700 mt-0'>Description:</h5>
                                            <p>{startUp?.description}</p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row  w-100 m-0 p-0 ">
                        <div className={'d-flex col-12 mb-2   pe-3 flex-column justify-content-start align-items-start  pb-1 m-0 p-0 h-100'}>
                            <h5 className='fw-700 mt-0'>Pitch:</h5>
                            {isEditView ?
                                <>
                                    <textarea
                                        style={{ minHeight: "120px" }}
                                        placeholder='Add pitch'
                                        {...formik.getFieldProps('pitch')}
                                        className="form-input"
                                        onChange={formik.handleChange}
                                        onBlur={() => formik.setFieldTouched("pitch", true)}
                                        value={formik.values.pitch}
                                        name="pitch"
                                    />
                                    {formik.errors.pitch && formik.touched.pitch && <div className='text-error ms-2' id="pitch">{formik.errors.pitch}</div>}
                                </>
                                :

                                <p className='mb-4 pe-1'>{startUp?.pitch}</p>
                            }
                        </div>
                    </div>
                </div>
            </form >
            <form onSubmit={formikTag.handleSubmit} id="form2" autoComplete='off'>
                <div className={clsx(" m-0 p-0  container-fluid ", {
                    "pe-4": !tablet,
                    "pe-3": tablet
                })}>
                    <div className={" m-0 p-0 row d-flex tag-container flex-wrap"}>
                        {isEditView ?
                            <>
                                <div className={clsx("pt-4  ",
                            {"col-12 ps-0 pb-2":tablet},
                            {"col-3 pb-4 border-right-black":!tablet})} >
                                    <h5 className='fw-700 ms-4 '>Tags: </h5> 
                                    <div className='d-flex'>
                                        <input
                                            autoComplete="new-password"
                                            style={{ borderRight: "none" }}
                                            placeholder='Add tag'
                                            {...formikTag.getFieldProps('tag')}
                                            className="form-input ms-4 w-50"
                                            type="text"
                                            onChange={formikTag.handleChange}
                                            onBlur={() => { formikTag.setFieldTouched("tag", true) }}
                                            value={formikTag.values.tag}
                                            name="tag"
                                            />
                                        <Button
                                            disabled={
                                                formikTag.isSubmitting ||
                                                !formikTag.isValid ||
                                                !formikTag.touched ||
                                                !formikTag.values.tag
                                            }
                                            padding="0px 20px" type="submit" form="form2" className='' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='add' />
                                        {formikTag.errors.tag && formikTag.touched.tag && <div id="feedback" className='text-error'>{formikTag.errors.tag}</div>}
                                    </div>
                                </div>
                                    
                                <div className={clsx(" d-flex  align-items-start ",
                                {"col-12 pt-2 pb-4 ps-3":tablet},
                                {"col-9":!tablet})} >
                                    <ul className='d-flex flex-wrap align-items-start  m-0 p-0 mt-2 ' style={{ listStyleType: "none" }} >
                                        {startUp?.tags?.map((tag) => {
                                            return <li key={tag.value} className='tag '>
                                                {tag.label}
                                                <span className='cursor-pointer ms-2'
                                                    onClick={() => removeTag(tag.value as string)}>
                                                    x
                                                </span>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            </>

                            :

                            <div className="col-12 d-flex  mt-4 mb-4" >
                                <h5 className='fw-700  '>Tags:</h5>
                                <ul className='d-flex flex-wrap' style={{ listStyleType: "none" }} >
                                    {startUp?.tags?.map((tag, index) => {
                                        return <li key={tag.value} className='tag'>{tag.label}</li>
                                    })}
                                </ul>
                            </div>
                        }

                    </div>
                </div>
            </form >
            {isEditView &&
                <div className='d-flex justify-content-end mt-4 me-4 '>
                    <Button primary text={"CANCEL"} background={"transparent"}
                        color={"black"} borderColor={"var(--black)"}
                        fontWeight={'800'} uppercase
                        className='mt-1 ms-3'
                        onClick={() => {
                            setIsEditView(false);
                            setDeleteImageCover(false);
                            setDeleteImageLogo(false);
                            formik.resetForm();
                        }} />
                    <Button
                        disabled={
                            formik.isSubmitting ||
                            !formik.isValid ||
                            !formik.touched
                        }
                        type="submit"
                        form="form1" className='mt-1 ms-3'
                        color='var(--white)' background='var(--primary)'
                        borderColor='var(--primary)' fontWeight={'800'}
                        uppercase primary text='save' />
                </div>
            }

        </>
    );
}


